export const SET_PROPRIETY_CONTACT= 'SET_PROPRIETY_CONTACT';
export const SET_CONTACT = 'SET_CONTACT';
export const RESET_CONTACT = 'RESET_CONTACT';
export const SET_CONTACTS = 'SET_CONTACTS';
export const VIDE_CONTACTS = 'VIDE_CONTACTS';
export const SET_MANY_CONTACTS = 'SET_MANY_CONTACTS';
